import React, { Component, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { getDefaultLanguage } from './actions/AppAction';

import './App.css';

//import MessageBox from './components/MessageBox'


// 从'react-intl'中引入addLocaleData,IntlProvider两个格式化组件；
import { addLocaleData, IntlProvider } from 'react-intl';

/*
 *引入与navigator.languages[0]所对应的语言；
 *如果没有引入对应的语言，会使用默认的“en”；
 *导致FormattedMessage的映射不会成功；
 */
import zh from 'react-intl/locale-data/zh';
import en from 'react-intl/locale-data/en';
import ja from 'react-intl/locale-data/ja';
/*
 *引入自定义的映射表；
 *通过与FormattedMessage的id值来当索引映射返回值；
 */
import zh_CN from './locale/zh_CN';
import en_US from './locale/en_US';
import ja_JP from './locale/ja_JP';
import zhCN from 'antd/es/locale/zh_CN';
import { ConfigProvider } from "antd";
import { MAX_CLIENT_WIDTH } from "./modules/WMS/Enums";
import { Link, Route, Routes } from "react-router-dom";
import { RoutePath } from './constants/RoutePath';
import WMSZoneList from './modules/WMS/views/Mobile/Zone/List/Index';
import WMSZoneMap from './modules/WMS/views/Mobile/Zone/Map/Index';
import WMSZoneDetail from './modules/WMS/views/Mobile/Zone/Detail/DetailIndex';
import WMSZoneSearchFuzzy from './modules/WMS/views/Mobile/Zone/SearchFuzzy/SearchFuzzyIndex';
import HocElement from './HocElement';
import Login from './modules/Login/views/login'
import HomePage from './modules/WMS/views/Mobile/Home/index'
import MinePage from './modules/WMS/views/Mobile/Mine/index'
import InfoCenterListPage from './modules/WMS/views/Mobile/InfoCenterList/index'
import ArticleDetailsPage from './modules/WMS/views/Mobile/ArticleDetails/index'
import Case from './modules/WMS/views/Mobile/Case/index'
import Collect from './modules/WMS/views/Mobile/Collect/index'
import YSFClass from './class/YSFClass'
import wxconfig from './utils/wxConfig';
import warningPng from './images/home/warning.png'
import {
    CloseCircleOutlined
} from '@ant-design/icons';
import { CACHE_SESSION_USER } from './constants/Profile';
// import VConsole from 'vconsole';

// const vConsole = new VConsole();
/*
 *messages是render()时IntlProvider组件所传的props，属性名固定：messages；
 *messages返回值为映射表，比如：'react-intl/locale-data/zh'&&'./locale/zh_CN'；
 */
let messages = {};
messages["en-US"] = en_US;
messages["zh-CN"] = zh_CN;
messages["ja-JP"] = ja_JP;
/*
 *获取浏览器设置的语言；
 *按我demo中的设置，返回["zh-CN", "zh", "en-US", "en"]，排序与语言设置顺序一直；
 */
const languages = navigator.languages;
const currentLang = "zh-CN";
//console.log("languages: ", languages);
//console.log("language: ", currentLang);
// 载入语言数据；
//载入一个addLocaleData(zh);
//载入多个；
addLocaleData([...zh, ...en, ...ja]);

const App = (props) => {
    const [open, setOpen] = useState(false)
    const [countDownTime, setCountDownTime] = useState(5)
    const userInfo = props.userInfo

    useEffect(() => {
        initCustomer()
    }, [userInfo])

    const initCustomer = async () => {
        await YSFClass.init(true)
        if (userInfo) {
            window.ysf('config', {
                uid: userInfo.id,
                name: userInfo.fullName,
                email: userInfo.email,
                mobile: userInfo.mobile,
                data: JSON.stringify([
                    { key: 'real_name', value: userInfo.fullName },
                    { key: 'mobile_phone', value: userInfo.mobile },
                    { key: 'email', value: userInfo.email },
                ]),
            })
        }
    }

    useEffect(() => {
        props.dispatch(getDefaultLanguage());
        YSFClass.init()
    }, [])



    const closeFn = () => {
        setOpen(false)
    }

    const language = props.currentLanguage ? props.currentLanguage : currentLang;

    return (
        <IntlProvider key={language} locale={language} messages={messages[language]}>
            <ConfigProvider locale={zhCN}>
                <div className="page-container-mobile">
                    <div style={{ height: "100vh" }}>
                        <Routes>
                            <Route path="/" element={<HocElement Component={HomePage} />} />
                            <Route path="/mine" element={<HocElement Component={MinePage} />} />
                            <Route path="/case" element={<HocElement Component={Case} />} />
                            <Route path={RoutePath.WMS_ZONE_LIST.path} element={<HocElement Component={WMSZoneList} />} />
                            <Route path={RoutePath.WMS_ZONE_MAP.path} element={<HocElement Component={WMSZoneMap} />} />
                            <Route path={RoutePath.WMS_ZONE_DETAIL.path} element={<HocElement Component={WMSZoneDetail} />} />
                            <Route path={RoutePath.WMS_ZONE_SEARCH_FUZZY.path} element={<HocElement Component={WMSZoneSearchFuzzy} />} />
                            <Route path="/login" element={<HocElement Component={Login} />} />
                            <Route path="/collect" element={<HocElement Component={Collect} />} />
                            <Route path="/infoCenterList" element={<HocElement Component={InfoCenterListPage} />} />
                            <Route path="/articleDetails/:id" element={<HocElement Component={ArticleDetailsPage} />} />
                        </Routes>
                        {
                            open && <div className='warning-img'>
                                {
                                    countDownTime > 0 ? <div className='countDownTime'>
                                        <div>{countDownTime}秒后可关闭</div>
                                    </div> :
                                        <CloseCircleOutlined onClick={() => { closeFn() }} style={{ color: '#fff' }} className='warningPngClose' />
                                }

                                <img src={warningPng} />
                            </div>
                        }
                    </div>
                </div>
            </ConfigProvider >
        </IntlProvider >
    );


}



function mapStateToProps(store) {
    return {
        currentLanguage: store.AppReducer.currentLanguage,
        userInfo: store.AppReducer.userInfo
    }
}

export default connect(mapStateToProps)(App);